<template>
  <section>
    <h4>
      Step {{ step }}: What pot odds do you have facing the {{ streetToCall }} bet?
      <toggle-help-button
        v-bind:helpAreaVisible="helpAreaVisible"
        v-on:toggleHelp="toggleHelp()"
      />
    </h4>
    <div class="well help-section" v-if="helpAreaVisible">
      <h3>What are pot odds?</h3>
      <p>The ratio of the pot size to the size of the bet you need to call.</p>
      <p>For example, suppose the pot is $10 and your opponent bets $10. Now the pot is $20 and you need to call $10. So the ratio is <code>20:10</code>, or <code>2:1</code>.</p>
      <h3>But what about when the numbers aren't clean like they are in your example?</h3>
      <p>You estimate.</p>
      <p>If the pot is $18 and you need to call $10, round up to <code>2:1</code>. If it's $12, round down to <code>1:1</code>. Exact numbers would be nice, but it's impractical to figure them out when you're at the tables.</p>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="potOdds === '4:1'" v-bind:disabled="!authorized" v-on:change="$emit('setPotOdds', '4:1')">
        4:1
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="potOdds === '3:1'" v-bind:disabled="!authorized" v-on:change="$emit('setPotOdds', '3:1')">
        3:1
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="potOdds === '2:1'" v-bind:disabled="!authorized" v-on:change="$emit('setPotOdds', '2:1')">
        2:1
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="potOdds === '3:2'" v-bind:disabled="!authorized" v-on:change="$emit('setPotOdds', '3:2')">
        3:2
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" v-bind:checked="potOdds === '1:1'" v-bind:disabled="!authorized" v-on:change="$emit('setPotOdds', '1:1')">
        1:1
      </label>
    </div>
    <div class="radio">
      <label>
        <input
          type="radio"
          v-bind:checked="!['4:1', '3:1', '2:1', '3:2', '1:1'].includes(potOdds)"
          v-bind:disabled="!authorized"
          v-on:input="$emit('setPotOdds', customPotOddsLHS + ':1')"
        >
        <input
          v-model="customPotOddsLHS"
          type="number"
          v-bind:disabled="!authorized"
          v-on:input="$emit('setPotOdds', customPotOddsLHS + ':1')"
          min="1"
          step="0.1"
        >-to-1
      </label>
    </div>
  </section>
</template>

<script>
import ToggleHelpButton from '@/components/guided-analyses/help/toggle-help-button';

export default {
  name: 'pod-odds-selector',
  components: {
    'toggle-help-button': ToggleHelpButton,
  },
  props: ['streetToCall', 'potOdds', 'numOpponents', 'authorized'],
  data: function () {
    return {
      helpAreaVisible: false,
      customPotOddsLHS: 1,
    };
  },
  mounted: function () {
    if (!['4:1', '3:1', '2:1', '3:2', '1:1'].includes(this.potOdds)) {
      this.customPotOddsLHS = this.potOdds.split(':')[0];
    }
  },
  computed: {
    step: function () {
      if (this.streetToCall === 'flop') {
        return 5 + (this.numOpponents);
      } else if (this.streetToCall === 'turn') {
        return 6 + (this.numOpponents * 2);
      } else if (this.streetToCall === 'river') {
        return 7 + (this.numOpponents * 3);
      }
    },
  },
  methods: {
    toggleHelp: function () {
      this.helpAreaVisible = !this.helpAreaVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/help-section';
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-call/pot-odds-selector.vue